import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Cookies } from 'react-cookie';
/* eslint-disable @typescript-eslint/no-unused-vars */

const cookies = new Cookies();

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_HOST,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = cookies.get('token');

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

// const baseQueryWithReauth = async (
//   args: any,
//   api: any,
//   extraOptions: any
// ): Promise<any> => {
//   let result = await baseQuery(args, api, extraOptions);

//   if (result?.error?.status === 403) {
//     // send refresh token to get new access token
//     const refreshResult = await baseQuery(
//       'v1/user/auth/refresh-token',
//       api,
//       extraOptions
//     );
//     if (refreshResult?.data) {
//       const user = api.getState().auth.user;
//       // store the new token
//       // api.dispatch(setCredentials({ ...refreshResult.data, user }));
//       // retry the original query with new access token
//       result = await baseQuery(args, api, extraOptions);
//     } else {
//       // api.dispatch(removeToken());
//       // api.dispatch(removeUser());
//     }
//   }

//   return result;
// };

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: ['Ad', 'Profile', 'Balance', 'Login'],
  endpoints: () => ({}),
});
